import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  private searchQuery = new BehaviorSubject<string>('');
  searchQuery$ = this.searchQuery.asObservable();

  updateSearch(query: string) {
    this.searchQuery.next(query);
  }

  private pages = [
    { name: 'Terminology', terms: ['geo', 'hierarchy', 'thc', ''] },
    { name: 'Market Benchmarks', terms: ['Market', 'benchmark','Segments', 'benchmarks','Average','Market Low','Market High','Mid-Low','Mid-High'] },
    { name: 'Terminal Handling Charges', terms: ['contract1','THC Methodology', 'handling', 'charges', 'thc','THCs' , 'Handling' , 'Terminal', 'Terminal Handling Charges'] },
    { name: 'Geo-Hierarchy Methodology', terms: ['geo', 'hierarchy','Contracted','Breakdown','Regional','Rates','Indicator','Geo-Hierarchy','Hierarchy'] },
    { name: 'Ocean Rate Methodology', terms: ['Ocean', 'rate','Bunker','Adjustment','Container Types','Factor','Canal','Bunker Adjustment Factor','Currency Adjustment Factor','Emissions Trading System' ,'ETS','BAF','CAF'] },
    { name: 'Contract Length', terms: ['contract', 'length','Short','Long'] },
    { name: 'Market Metrics', terms: ['market', 'metrics','Regional Aggregation','THC Methodology'] },
    { name: 'Contracted Within', terms: ['contracted', 'within','Contract Age','All Contracts','Last 6 Months','Last 3 Months'] },
    { name: 'Container Types', terms: ['container', 'Types','DC','RE','RF','TK','DC','HC','RH', '20', '40','20 foot dry cargo','high cube','reefer','foot tank'] },
    { name: 'Future Rates', terms: ['future', 'rates'] },
    { name: 'Coverage', terms: ['coverage', 'contract2'] },
    { name: 'Contract Validity', terms: ['contract', 'validity','within','Contract Age','All Contracts','Last 6 Months','Last 3 Months'] },
    // Add more pages and terms as needed
  ];

  search(term: string) {
    if (!term.trim()) {
      return [];
    }

    return this.pages
      .filter((page) => page.terms.some((t) => t.toLowerCase().includes(term.toLowerCase())))
      .map((page) => page.name);
  }
}
